import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-slate-600 text-white px-5 py-5'>
        <div>
            <h3 className='font-semibold text-3xl tracking-tighter'>Shopping</h3>
        </div>
        <h3 className='text-center mt-4'>2020 &copy; Shopping ecommerce</h3>
    </footer>
  )
}

export default Footer